export const setter = propName => `set${propName}`;
